var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCursor = function SvgIconCursor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.036 2.551a1.75 1.75 0 0 1 .742.054l.12.04L19.446 8.1h.004l.123.054c.241.113.453.28.62.487l.08.107.071.114a1.75 1.75 0 0 1-.917 2.52v.001l-4.864 1.766 5.643 5.642.07.076a1 1 0 0 1-1.408 1.408l-.076-.07-5.643-5.642-1.767 4.865a1.75 1.75 0 0 1-3.282.022v-.003L2.643 4.898a1.75 1.75 0 0 1-.071-.985l.03-.122a1.75 1.75 0 0 1 .443-.745l.091-.086a1.75 1.75 0 0 1 .776-.386zm5.698 15.558 1.954-5.372.001-.004.075-.175q.128-.257.332-.461l.142-.128q.224-.179.494-.28h.004l5.372-1.954L4.71 4.71z"
  })));
};
export default SvgIconCursor;